export default "__VITE_ASSET__0c78aa03__$_#icon-vector__"